module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Other1-5511135009747a98d2a4b84e8079c276.svg";